module.exports = __webpack_public_path__ + "static/media/banner_home_privateroom.2b30a471.jpg";